export default (props) => (
    /**
     * Ícone que faz referencia 
     * a imagem em paisagem
     */
    <svg 
        width="21" 
        height="16" 
        viewBox="0 0 21 16" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
    <rect 
        x="19.7334" 
        y="14.8984" 
        width="19.0578" 
        height="13.4708" 
        transform="rotate(-180 19.7334 14.8984)" 
        stroke="#3C71DD"
        fill={"white"}
    />
    <rect 
        x="18.5537" 
        y="9.36719" 
        width="4.36972" 
        height="16.8393" 
        transform="rotate(90 18.5537 9.36719)" 
        fill="#3C71DD"
    />
    </svg>

  );